<template>
<svg class="icon__report-flag"
width="32"
xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.66 27.77"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M14.82 20.66a1.2 1.2 0 0 1-1.21-1.2 1.19 1.19 0 0 1 .35-.85 1.22 1.22 0 0 1 2.07.85 1.13 1.13 0 0 1-.36.85 1.16 1.16 0 0 1-.85.35zM16 2.84l-.26 14.21h-1.89L13.6 2.84z"/><path class="cls-1" d="M28.66 1v21.63H6.27l-.27.16L1 26V1h27.66m.18-1H.82A.82.82 0 0 0 0 .82v26.95l6.52-4.14h22.32a.82.82 0 0 0 .82-.81v-22a.82.82 0 0 0-.82-.82z"/></g></g></svg>
</template>

<script>
export default {
    name: "IconReportFlag"
};
</script>


<style scoped lang="scss">
@import '@/assets/scss/all.scss';

.icon__report-flag {
	fill: $sony-white;
	path {
		transition: all 0.3s ease;
	}
}
</style>
